import {basicContext} from "../../../../utils/contextUtils";
import _ from "lodash";
import {setFieldVisibility} from "../../../../../apps/KpModule/actions";
import {hasDuplicates} from "../../utils/usefulFunctions";
import Errors from "../../../../utils/Errors";

export const entity = {
    name: 'AnalyticalMesh',
    facets: [
        {name: 'codeName', nameOptional: false, uniqueName: false, uniqueCode: true}
    ],
    fields: [
        {path: 'attachment', type:'AnalyticalSubAxis', link:'MTM', fieldPath:['nameWithAnalyticalAxis']},
        {path: "isCreatedAutomatically", type: 'boolean'},
        {
            path: 'nameWithAttachment',
            fieldPath: ['attachment.id', 'attachment.name', 'attachment.analyticalAxis', 'name'],
            $f: function (object, context, callback) {
                if(!context.translateName) return callback(null, `${object.name} : ( ${object.attachment.map(subAxis => ' ' + subAxis?.analyticalAxis?.name + ' : ' + subAxis?.name).toString()} )`)
                callback(null, `${context.translateName(object.name)} : ( ${object.attachment.map(subAxis => ' ' + context.translateName(subAxis?.analyticalAxis?.name) + ' : ' + context.translateName(subAxis?.name))} )`)
            }
        },
        {
            path: 'attachmentDetails',
            fieldPath: ['attachment.id', 'attachment.name', 'attachment.analyticalAxis', 'name'],
            $f: function (object, context, callback) {
                if(!context.translateName) return callback(null, `${object.attachment.map(subAxis => ' ' + subAxis?.analyticalAxis?.name + ' : ' + subAxis?.name).toString()}`)
                callback(null, `${object.attachment.map(subAxis => ' ' + context.translateName(subAxis?.analyticalAxis?.name) + ' : ' + context.translateName(subAxis?.name))}`)
            }
        },
        {
            path:'attachmentsNumber',
            f: function () {
                return this.attachment?.length
            }
        },
    ],
    filters: [
        {
            name: 'byThisSubAxisClient',
            tKey: 'analyticalSubAxis',
            isDefault: false,
            client: true,
            path: 'analyticalSubAxis',
            object: 'AnalyticalSubAxis',
            display: 'nameWithAnalyticalAxis',
            clearable: true,
            query: function(context) {
                const analyticalSubAxisID = _.get(context, 'data.analyticalSubAxis.id')
                return analyticalSubAxisID ? {"attachment": {$elemMatch: {$eq: new global.ObjectID(analyticalSubAxisID)}}} : {}
            }
        },
        {
            name: 'byThisSubAxis',
            isDefault: false,
            query: function(context) {
                const organizationID = _.get(context.data, 'subAxis.id')
                return organizationID? {"attachment": {$elemMatch : {$eq : new global.ObjectID(organizationID)}}} : {"attachment": "0"}
            }
        },
        {
            name: "byBudgetAxis",
            isDefault: false,
            async: true,
            query: function(context, callback) {
                global.app.SE.AnalyticalSubAxis.find(
                    {
                        ...basicContext(context),
                        fieldPath: ['analyticalAxis'],
                        query: {
                        }
                    },(e, subAxes) => {
                        if (e) return callback(e)
                        const subAxesInBudgetAxes = subAxes.filter( subAxis => subAxis.analyticalAxis.isBudgetAxis).map( subAxisInBudget => new global.ObjectID(subAxisInBudget.id))
                        const query = !!subAxesInBudgetAxes.length ? {"attachment": {$elemMatch: {$in: subAxesInBudgetAxes}} } : {_id: null}
                        callback(e, query)
                    }
                )
            }
        },
        {
            name: 'createdManually',
            isDefault: false,
            query: function(context) {
                return {"isCreatedAutomatically": false}
            }
        }
    ],
    beforeSave: function (newObject, oldObject, context, callback) {
        const IDs = newObject.attachment.map(subAxis => subAxis.analyticalAxis.id.toString())
        if (hasDuplicates(IDs)){
            callback(new Errors.ValidationError(context.tc('attachedToTwoAnalyticalSubAxesFromSameAxisError')))
        }
        else {callback(null, newObject, oldObject)}
    }
}

export const module_ = {
    object: 'AnalyticalMesh',
    category: {
        path: 'referencial',
        icon: 'briefcase'
    },
    defaultSortBy: 'name',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [ 'code',
            {path: 'name', type: 'translatedText'},
            {path: 'attachment'},
            {path: 'attachmentsNumber'}
        ],
        form: {
            fields: [
                {path: 'code', editable: false},
                {path: 'name', type: 'textarea', placeholder: 'fr:: nom en français\nen:: name in english\n...'},
                {path: 'attachment', display: 'nameWithAnalyticalAxis', tKey: 'attachments'},
                {path: 'isCreatedAutomatically'}
            ],
            onOpen: ({ store, module, t }) => {
                const isCreatedAutomaticallyField = module.viewMap.form.fields.find(field => field.path === 'isCreatedAutomatically')
                store.dispatch(setFieldVisibility(isCreatedAutomaticallyField.id, false))
            }
        },
    },
    filters :['byThisSubAxisClient']
}
